export const signupFormFields = {
  companyName: '',
  country: 'US',
  firstName: '',
  lastName: '',
  email: '',
  street1: '',
  street2: '',
  city: '',
  postalCode: '',
  state: '',
  phone: '',
  emeaCompanyType: null,
  vatNumber: '',
};

export const requiredFormFields = [
  'city',
  'companyName',
  'country',
  'email',
  'firstName',
  'lastName',
  'postalCode',
  'state',
  'street1',
];
